// Angular
import {
  APP_BOOTSTRAP_LISTENER,
  Type,
  Inject,
  InjectionToken,
} from '@angular/core';

// NgRx
import { EffectSources } from '@ngrx/effects';

export function bootstrapEffects(effects: Type<any>[], sources: EffectSources) {
  return () => {
    effects.forEach((effect) => sources.addEffects(effect));
  };
}

export function createInstances(...instances: any[]) {
  return instances;
}

export function provideBootstrapEffects(
  token: InjectionToken<unknown>,
  effects: Type<any>[]
) {
  return [
    effects,
    {
      provide: token,
      deps: effects,
      useFactory: createInstances,
    },
    {
      provide: APP_BOOTSTRAP_LISTENER,
      multi: true,
      deps: [[new Inject(token)], EffectSources],
      useFactory: bootstrapEffects,
    },
  ];
}
